import type { JSX } from 'react';

import { ErrorPageContainer } from './ErrorPage';

export function NotFoundContainer(): JSX.Element | null {
	return <ErrorPageContainer status={404} />;
}
